import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { RegistroService } from '../../../services/auth/registro.service';

import { SelectItem } from 'primeng/api';
import {environment } from '../../../../environments/environment';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css']
})
export class RegistroComponent implements OnInit {
  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código del mensaje de respuesta a mostrar en la función.
   * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
   * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
   */
    registrar: FormGroup;
    visibleSpinner = false;
    personaData: any = [];
    tratamientoData: any = [];
    generoData: any = [];
    personas: any = [];
    tratamientos: any = [];
    generos: any = [];
    documentos: SelectItem[];
    Dom = false;
    Doc = false;
    DocDUI = false;
    DocPasaporte = false;
    DocCarnet = false;
    regExAlfabetico: string = environment.regExAlfabetico;
    regExAlfanumerico: string = environment.regExAlfanumerico;
    regExTelefono: string = environment.regExTelefono;
    regExNumeros: string = environment.regExNumeros;
    regExPasaporte: string = environment.regExPasaporte;
    regexNIT: string = environment.regexNIT;
    val: any;
    dui: any;
    duiArch: any;
    nit: any;
    nitArch: any;
    carnet: any;
    carnetArch: any;
    pasa: any;
    pasaArch: any;
    file1: File;
    file2: File;
    file3: File;
    checkConditions: boolean = false;
    displayModalConditions = false;
    // Variables para mensaje
    code: any;
    titulo: any;
    detalle: any;
    TemsConditionsText: any;

    step: number = 2;
    userType: any;
    newUser: any = 1; //0: usuario existente, 1: nuevo usuario, 2: no seleccionado
    newUserOptions: any = [
      {label: 'Soy un nuevo usuario', value: 1},
      {label: 'Poseo un usuario en portal en línea', value: 0}
    ];
  

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private registroService: RegistroService) { }

  ngOnInit(): void {
      this.registrar = this.formBuilder.group({
          /**
           * Aquí se definen las validaciones que se hacen en el formulario.
           */
          tipo_persona: [null, [Validators.required]],
          nombre: [null, [Validators.required, Validators.pattern(this.regExAlfabetico),
              Validators.minLength(3), Validators.maxLength(100)]],
          apellido: [null, [Validators.required, Validators.pattern(this.regExAlfabetico),
              Validators.minLength(3), Validators.maxLength(100)]],
          correo: [null, [Validators.required, Validators.email,
              Validators.maxLength(100)]],
          telefono: [null, [Validators.required, Validators.pattern(this.regExTelefono),
              Validators.minLength(6), Validators.maxLength(20)]],
          telefono_secundario: [null, [Validators.pattern(this.regExTelefono),
              Validators.minLength(6), Validators.maxLength(20)]],
          genero: [null, [Validators.required]],
          tratamiento: [null, [Validators.required]],
          doc: ['', [Validators.required]],
          dui: [null],
          carnet_residente: [null],
          pasaporte: [null, [Validators.pattern(this.regExPasaporte)]]
      });
      this.visibleSpinner = true;
      this.cargarPersonas();
    }

  cargarPersonas(): void {
    this.registroService.getCatalogos().subscribe((res: any) => {
      /**
       * Para llevar los datos al listbox de tipo de persona,
       * se hace una petición desde el service,
       * el cual se debe importa y definir en el constructor.
       */
      // this.personaData = res.data.tipos_personas;
      res.data.tipos_personas.map((p, key) => {
        const item = {
          label: p.nombre,
          value: p.codigo,
        };
        this.personaData.push(item);
        this.documentos = [
          { label: 'Debe seleccionar un tipo de persona', value: null }
        ];
      });
      this.personas = this.personaData;
      /**
       * Para llevar los datos al listbox de tipo de persona.
       */
      this.generoData = res.data.generos;
      let generoDataTemp = [];
      this.generoData.map((p, key) => {
        let item = {
          label: p.nombre,
          value: p.codigo,
        };
        generoDataTemp.push(item);
      });

      this.generos = generoDataTemp;

      /**
       * Para llevar los datos al listbox de tratamiento.
       */
      this.tratamientoData = res.data.tratamientos;
      let tratamientoDataTemp = [];
      this.tratamientoData.map((p, key) => {
        let item = {
          label: p.nombre,
          value: p.id,

        };
        tratamientoDataTemp.push(item);
      });

      this.tratamientos = tratamientoDataTemp;
      this.visibleSpinner = false;
    });
  }

    showModal(event = null): void {
      this.displayModalConditions = true;
      if(event){
        event.preventDefault();
        event.stopPropagation();
      }
    }

    changeConditions(): void{
      this.checkConditions = !this.checkConditions;
    }

    per(id): void {
        /**
         * Esta función es la que permite
         * llenar las opciones del documentos en el listbox,
         * dependiendo del tipo de persona que se seleccione
         */
      this.DocDUI = false;
      this.DocCarnet = false;
      this.DocPasaporte = false;

      this.Dom = true;
      if (id.value === 'N') {
        this.registrar.get('doc').reset();
        this.Doc = false;
        this.documentos = [
              {label: 'DUI', value: 1}
          ];
      } else if (id.value === 'E') {
          this.registrar.get('doc').reset();
          this.Doc = false;
          this.documentos = [
              {label: 'Pasaporte', value: 3},
              {label: 'Carnet de Residente', value: 2}
          ];
      }
    }

    doc(id): void {
        /**
         * Según el tipo de documento que se desee agregar,
         * la validación de los formularios cambiara con esta función.
         */
        const sw = id.value;
        this.Doc = true;
        const DUIControl = this.registrar.get('dui');
        //const NITControl = this.registrar.get('nit');
        const CarnetControl = this.registrar.get('carnet_residente');
        const PasaporteControl = this.registrar.get('pasaporte');
        switch (sw) {
            case 1:
                DUIControl.reset();
                //NITControl.reset();
                DUIControl.setValidators([Validators.pattern(this.regExNumeros),
                    Validators.maxLength(9)]);
                //NITControl.setValidators([Validators.pattern(this.regexNIT),Validators.maxLength(17)]);
                CarnetControl.setValidators(null);
                PasaporteControl.setValidators(null);
                this.DocDUI = true;
                this.DocCarnet = false;
                this.DocPasaporte = false;
                this.val = 'D';
                break;
            case 2:
                DUIControl.setValidators(null);
                //NITControl.setValidators(null);
                CarnetControl.reset();
                PasaporteControl.reset();
                CarnetControl.setValidators([Validators.pattern(this.regExAlfanumerico),
                    Validators.minLength(5), Validators.maxLength(20)]);
                PasaporteControl.setValidators([Validators.pattern(this.regExPasaporte),
                    Validators.minLength(5), Validators.maxLength(20)]);
                this.DocDUI = false;
                this.DocCarnet = true;
                this.DocPasaporte = true;
                this.val = 'C';
                break;
            case 3:
                DUIControl.setValidators(null);
                //NITControl.setValidators(null);
                CarnetControl.setValidators(null);
                PasaporteControl.reset();
                PasaporteControl.setValidators([Validators.pattern(this.regExPasaporte),
                    Validators.minLength(5), Validators.maxLength(20)]);
                this.DocDUI = false;
                this.DocCarnet = false;
                this.DocPasaporte = true;
                this.val = 'P';
                break;
            default:
        }
    }

    archivo(file, id): void {
        /**
         * Esta función almacena los documentos en una variable
         * al momento de ser seleccionados en el componente
         */
      if (id === 1) {
          if (file.files && file.files[0]) {
              this.file1 = file.files[0];
          }
      } else if (id === 2) {
          if (file.files && file.files[0]) {
              this.file2 = file.files[0];
          }
      } else if (id === 3) {
        if (file.files && file.files[0]) {
            this.file3 = file.files[0];
          }
      }
    }

    buscar(): void {
        const duiControl = this.registrar.get('dui');
        const rawDui = duiControl?.value ?? '';
        const digits = String(rawDui).replace(/\D/g, '');
        const dui = digits.length > 1 ? digits.slice(0, digits.length - 1) + '-' + digits.slice(-1) : digits;
        if (!dui) {
            this.code = 'form.warn.20';
            this.registrar.value.nombre = "";
            this.registrar.get('nombre')?.setValue("");
            this.registrar.value.apellido = "";
            this.registrar.get('apellido')?.setValue("");
            setTimeout(() => this.code = null, 1500);
            return;
        }

        this.visibleSpinner = true;
        // Llamar al servicio. Asegúrate de implementar buscarPorDUI en RegistroService.
        this.registroService.buscarPorDUI(dui).subscribe({
            next: (res: any) => {
                this.visibleSpinner = false;
                if (res?.success && res?.data) {
                    // Rellenar formulario con los datos encontrados (ajusta nombres según respuesta)
                    const persona = res.data?.persona ?? {};
                    this.registrar.value.nombre = persona.nombres;
                    this.registrar.get('nombre')?.setValue(persona.nombres);
                    this.registrar.value.apellido = persona.apellidos;
                    this.registrar.get('apellido')?.setValue(persona.apellidos);
                    const tratamientoEncontrado = this.tratamientos.find(t => t.label.toLowerCase() === (persona.profesion ?? '').toLowerCase());
                    if (tratamientoEncontrado) {
                        this.registrar.value.tratamiento = tratamientoEncontrado.value;
                        this.registrar.get('tratamiento')?.setValue(tratamientoEncontrado.value);
                    }
                    this.code = 'form.success.15';
                    setTimeout(() => this.code = null, 2000);
                } else {
                    this.code = 'form.error.14';
                    this.registrar.value.nombre = "";
                    this.registrar.get('nombre')?.setValue("");
                    this.registrar.value.apellido = "";
                    this.registrar.get('apellido')?.setValue("");
                    setTimeout(() => this.code = null, 4000);
                    return;
                }
            },
            error: (err) => {
                this.visibleSpinner = false;
                this.code = 'form.error.14';
                setTimeout(() => this.code = null, 4000);
            }
        });
    }
    limpiar(): void {
        this.registrar.reset();
        this.Doc = false;
        this.Dom = false;
        this.DocDUI = false;
        this.DocCarnet = false;
        this.DocPasaporte = false;
        this.file1 = undefined;
        this.file2 = undefined;
        this.file3 = undefined;
        this.code = null;
        this.titulo = null;
        this.detalle = null;
    }

    clearFile(id): void {
        /**
         * Si se vuelve a hacer otra selección de archivo,
         * la variable se vuelve null para solo mantener documento.
         */
        if (id === 1) {
            this.file1 = undefined;
        } else if (id === 2) {
            this.file2 = undefined;
        } else if (id === 3) {
            this.file3 = undefined;
        }
    }

    crear(): void {
        /**
         * Esta función es la que se encargar de hacer la petición
         * al service para consumir los datos con los que posteriormente
         * se le darán valor a los elementos del formulario.
         */
        this.visibleSpinner = true;
        const tipo_persona = this.registrar.value.tipo_persona;
        const nombre = this.registrar.value.nombre;
        const apellido = this.registrar.value.apellido;
        const telefono = this.registrar.value.telefono.replace('-', '');
        const telefono_secundario = this.registrar.value.telefono_secundario;
        const correo = this.registrar.value.correo;
        const genero = this.registrar.value.genero;
        const tratamiento = this.registrar.value.tratamiento;
        const checkConditions = this.checkConditions;
        if(!checkConditions){
          this.visibleSpinner = false;
          this.code = 'registro.warn.conditions';
          setTimeout(() => this.code = null, 500);
          return;
        }
        const val = this.val;
        
        switch (val) {
          case 'D':
            this.dui = this.registrar.value.dui;
            this.duiArch = this.file1;
            
            /*this.nit = this.registrar.value.nit;
            this.nitArch = this.file2;
            if (this.duiArch === undefined ||  this.dui === null  || this.dui === '') {
              this.visibleSpinner = false;
              this.code = 'registro.warn.12';
              setTimeout(() =
                this.code = null;
              }, 500);
            } else { */
              this.registarUsuario(tipo_persona, nombre, apellido, telefono, telefono_secundario, correo, genero, tratamiento,
                this.dui, null, null, null, null);
            /*} */
            break;
          case 'C':
            this.pasa = this.registrar.value.pasaporte;
            this.pasaArch = this.file3;
            this.carnet = this.registrar.value.carnet_residente;
            this.carnetArch = this.file2;
            if (this.carnetArch === undefined || this.pasaArch === undefined ||
                this.pasa === null || this.carnet === null || this.pasa === '' || this.carnet === '') {
              this.visibleSpinner = false;
              this.code = 'registro.warn.13';
              setTimeout(() => {
                this.code = null;
              }, 500);
            } else {
              this.registarUsuario(tipo_persona, nombre, apellido, telefono, telefono_secundario, correo, genero, tratamiento,
                null, this.carnet, this.carnetArch, this.pasa, this.pasaArch);
            }
            break;
          case 'P':
            this.pasa = this.registrar.value.pasaporte;
            this.pasaArch = this.file3;
            if (this.pasaArch === undefined || this.pasa === null || this.pasa === '') {
              this.visibleSpinner = false;
              this.code = 'registro.warn.14';
              setTimeout(() => {
                this.code = null;
              }, 500);
            } else {
              this.registarUsuario(tipo_persona, nombre, apellido, telefono, telefono_secundario, correo, genero, tratamiento,
                null, null, null, this.pasa, this.pasaArch);
            }
            break;
          default:
        }
    }

    registarUsuario(tipoPersona, nombre, apellido, telefono, telefonoSecundario, correo, genero, tratamiento,
                    dui, carnet, carnetFile, pasa, pasaFile): void {
      this.code = null;
      this.titulo = null;
      this.detalle = null;
      // Se limia localStorage antes de procesar el registro
      localStorage.clear();
      sessionStorage.clear();

      this.registroService.crearUsuario
      (tipoPersona, nombre, apellido, telefono, telefonoSecundario, correo, genero, tratamiento,
        dui, carnet, carnetFile, pasa, pasaFile).subscribe((res: any) => {
        if (res.success) {
          this.visibleSpinner = false;
          this.code = 'registro.success.default';
          sessionStorage.setItem('temp_mail_register', correo); 
          setTimeout(() => {
            this.router.navigate(['auth/confirm-user']);
          }, 1000);
        } else {
          this.visibleSpinner = false;
          let htmlMessage = '';
          htmlMessage = 'Error: ' + res.data.code + '<br>';
          if (res.data.extra.length > 0) {
            for (const value of res.data.extra) {
              htmlMessage += '<br>';
              htmlMessage += '&bull; ';
              htmlMessage += value;
            }
          } else {
            htmlMessage += '<br>';
            htmlMessage += res.data.message;
          }
          this.code = 'registro.warn.11';
          this.titulo = res.data.title;
          this.detalle = htmlMessage;
        }
      });
    }

    nextStep(step): void {
      this.step = step; 
    }
}
